//  @ts-nocheck
import { useFm } from '@better-bit-fe/base-hooks';
import React, { useEffect, useState, PropsWithChildren } from 'react';
import getConfig from 'next/config';
import { IRefer } from '~/types';
import styles from './index.module.less';
const { staticFolder } = getConfig().publicRuntimeConfig;

const HoverComp = (props: PropsWithChildren<IRefer>) => {
  const t = useFm();

  return (
    <div>
      {/* feedback */}
      <div className={`center ${styles.feedBack}`}>
        <a
          href="mailto:support@mufex.finance"
          className="btn-primary w-button"
          rel="noreferrer"
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M17.2221 15H9.44428L4.99984 18.3333V15H2.77762C2.48293 15 2.20031 14.8829 1.99194 14.6745C1.78357 14.4661 1.6665 14.1835 1.6665 13.8888V2.77774C1.6665 2.48305 1.78357 2.20044 1.99194 1.99206C2.20031 1.78369 2.48293 1.66663 2.77762 1.66663H17.2221C17.5167 1.66663 17.7994 1.78369 18.0077 1.99206C18.2161 2.20044 18.3332 2.48305 18.3332 2.77774V13.8888C18.3332 14.1835 18.2161 14.4661 18.0077 14.6745C17.7994 14.8829 17.5167 15 17.2221 15Z"
              stroke="black"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
          <span className={styles.backText}>{t('feedback')}</span>
        </a>
      </div>
      {/* h5 不展示social*/}
      <div className={`center ${styles.homeSocials}`}>
        <a
          href="https://twitter.com/mufex_Official/"
          title="Twitter"
          rel="noreferrer"
          target="_blank"
          className={styles.homeSocialItem}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.homeSocialIcon}
              d="M22.9022 5.00287C22.1905 5.30914 21.4423 5.52241 20.6762 5.6374C21.0344 5.576 21.5614 4.93123 21.7713 4.67026C22.09 4.2766 22.3329 3.82721 22.4877 3.34491C22.4877 3.30909 22.5235 3.25792 22.4877 3.23233C22.4696 3.22248 22.4494 3.21732 22.4288 3.21732C22.4082 3.21732 22.388 3.22248 22.37 3.23233C21.538 3.68286 20.6526 4.02672 19.7346 4.25577C19.7026 4.26554 19.6686 4.26642 19.6361 4.2583C19.6037 4.25019 19.574 4.23339 19.5504 4.20971C19.4789 4.12463 19.402 4.04429 19.3201 3.96921C18.9457 3.63375 18.5209 3.35919 18.0613 3.15558C17.4409 2.90104 16.7707 2.7908 16.1014 2.83319C15.452 2.87421 14.818 3.04839 14.2388 3.34491C13.6684 3.65753 13.1671 4.08223 12.765 4.5935C12.3421 5.11972 12.0367 5.73042 11.8695 6.38451C11.7316 7.00668 11.716 7.64972 11.8234 8.27786C11.8234 8.38532 11.8234 8.40067 11.7313 8.38532C8.08279 7.84802 5.08923 6.55338 2.64322 3.77475C2.53576 3.65194 2.47947 3.65194 2.39248 3.77475C1.3281 5.39178 1.84494 7.95036 3.1754 9.2143C3.35451 9.38317 3.53872 9.54692 3.73318 9.70043C3.12317 9.65713 2.52805 9.49182 1.9831 9.2143C1.88076 9.14778 1.82447 9.1836 1.81935 9.30641C1.80484 9.47668 1.80484 9.64786 1.81935 9.81813C1.92612 10.6341 2.2477 11.4071 2.75119 12.058C3.25468 12.709 3.92202 13.2145 4.68497 13.523C4.87096 13.6026 5.06476 13.6626 5.26322 13.7021C4.6985 13.8132 4.11931 13.8305 3.54896 13.7532C3.42615 13.7276 3.38009 13.7942 3.42615 13.9119C4.17837 15.9587 5.81075 16.583 7.00818 16.931C7.17193 16.9566 7.33568 16.9566 7.51989 16.9975C7.51989 16.9975 7.51989 16.9975 7.48919 17.0282C7.13611 17.673 5.70841 18.1079 5.05341 18.3331C3.85787 18.7625 2.5832 18.9267 1.31787 18.8141C1.1183 18.7834 1.07224 18.7885 1.02107 18.8141C0.969898 18.8397 1.02107 18.896 1.07736 18.9472C1.33322 19.116 1.58908 19.2644 1.85517 19.4077C2.64733 19.8398 3.48481 20.183 4.35236 20.4311C8.84525 21.6695 13.901 20.7586 17.2732 17.4069C19.924 14.7767 20.8553 11.1486 20.8553 7.5154C20.8553 7.37724 21.0241 7.29536 21.1214 7.22372C21.792 6.70121 22.3832 6.08413 22.8766 5.39178C22.962 5.28857 23.0058 5.15717 22.9994 5.02334V5.02334C22.9994 4.94658 22.9994 4.96194 22.9022 5.00287Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://t.me/mufex"
          title="Telegram"
          rel="noreferrer"
          target="_blank"
          className={styles.homeSocialItem}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.homeSocialIcon}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.2533 21.5492L22.9869 3.59063C23.083 3.12751 22.6279 2.74115 22.1869 2.9117L1.38254 10.9375C0.869073 11.1353 0.873473 11.8622 1.38841 12.0551L6.45767 13.947L8.41978 20.2572C8.54536 20.6611 9.03955 20.8106 9.36745 20.5424L12.1932 18.239C12.4894 17.9975 12.9113 17.9855 13.2207 18.2102L18.3174 21.9104C18.6682 22.1654 19.1654 21.9732 19.2533 21.5492ZM8.10363 12.94L18.0108 6.83821C18.1888 6.72891 18.3721 6.96965 18.219 7.11143L10.0428 14.7116C9.7553 14.9791 9.57001 15.3373 9.51742 15.7259L9.23904 17.7899C9.20195 18.0654 8.81503 18.0926 8.73884 17.826L7.66769 14.0622C7.54519 13.6329 7.72391 13.1743 8.10363 12.94Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://discord.com/invite/m6DD42s46n"
          title="Discord"
          rel="noreferrer"
          target="_blank"
          className={styles.homeSocialItem}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.homeSocialIcon}
              d="M20.0001 4.71912C22.5977 8.53826 23.8805 12.8461 23.401 17.8055C23.399 17.8265 23.388 17.8458 23.3708 17.8584C21.4037 19.3028 19.4979 20.1794 17.6188 20.7607C17.6042 20.7651 17.5885 20.7649 17.574 20.76C17.5595 20.7551 17.5469 20.7458 17.538 20.7334C17.1039 20.1294 16.7094 19.4925 16.3638 18.8238C16.344 18.7844 16.3621 18.737 16.403 18.7215C17.0294 18.4854 17.6251 18.2025 18.1981 17.8676C18.2432 17.8412 18.2461 17.7765 18.2044 17.7454C18.0828 17.6551 17.9623 17.5603 17.8471 17.4654C17.8255 17.4479 17.7965 17.4444 17.772 17.4562C14.0521 19.174 9.97705 19.174 6.2131 17.4562C6.18867 17.4453 6.15963 17.449 6.13864 17.4663C6.02364 17.5611 5.90289 17.6551 5.78243 17.7454C5.74074 17.7765 5.74419 17.8412 5.78962 17.8676C6.3626 18.1962 6.9583 18.4854 7.5839 18.7226C7.62444 18.7382 7.6437 18.7844 7.62358 18.8238C7.28548 19.4934 6.89103 20.1302 6.44885 20.7343C6.42959 20.7587 6.39797 20.7699 6.36807 20.7607C4.49788 20.1794 2.59205 19.3028 0.624977 17.8584C0.608589 17.8458 0.596802 17.8256 0.595077 17.8046C0.194303 13.5149 1.01109 9.17133 3.99275 4.71826C3.99993 4.70647 4.01086 4.69727 4.02351 4.69181C5.49062 4.01849 7.06238 3.52312 8.70515 3.24023C8.73505 3.23563 8.76495 3.24943 8.78048 3.27588C8.98345 3.63525 9.21546 4.09611 9.37244 4.47273C11.104 4.20823 12.8627 4.20823 14.6305 4.47273C14.7875 4.10416 15.0115 3.63525 15.2136 3.27588C15.2208 3.26275 15.2319 3.25224 15.2454 3.24584C15.259 3.23944 15.2742 3.23747 15.2889 3.24023C16.9325 3.52399 18.5043 4.01935 19.9702 4.69181C19.9832 4.69727 19.9938 4.70647 20.0001 4.71912V4.71912ZM10.2528 12.8755C10.2709 11.6073 9.34627 10.5579 8.18564 10.5579C7.03449 10.5579 6.11881 11.5981 6.11881 12.8755C6.11881 14.1525 7.0526 15.1927 8.18564 15.1927C9.33707 15.1927 10.2528 14.1525 10.2528 12.8755V12.8755ZM17.8951 12.8755C17.9132 11.6073 16.9886 10.5579 15.8282 10.5579C14.6768 10.5579 13.7611 11.5981 13.7611 12.8755C13.7611 14.1525 14.6949 15.1927 15.8282 15.1927C16.9886 15.1927 17.8951 14.1525 17.8951 12.8755V12.8755Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://www.youtube.com/channel/UC0VQ8_HuC8yeiJvEbrfmRqw"
          title="YouTube"
          rel="noreferrer"
          target="_blank"
          className={styles.homeSocialItem}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.homeSocialIcon}
              fillRule="evenodd"
              clipRule="evenodd"
              d="M21.3904 0.550588C22.4184 0.847059 23.2289 1.71529 23.5057 2.81647C24.0197 4.82824 23.9999 9.02118 23.9999 9.02118C23.9999 9.02118 23.9999 13.1929 23.5057 15.2047C23.2289 16.3059 22.4184 17.1741 21.3904 17.4706C19.5123 18 11.9999 18 11.9999 18C11.9999 18 4.50739 18 2.60954 17.4494C1.58154 17.1529 0.771002 16.2847 0.494232 15.1835C0 13.1929 0 9 0 9C0 9 0 4.82824 0.494232 2.81647C0.771002 1.71529 1.60131 0.825882 2.60954 0.529412C4.48763 0 11.9999 0 11.9999 0C11.9999 0 19.5123 0 21.3904 0.550588ZM15.8549 8.85281L9.60779 12.7069V4.9987L15.8549 8.85281Z"
              fill="white"
            />
          </svg>
        </a>
        <a
          href="https://blog.mufex.finance/"
          title="Medium"
          rel="noreferrer"
          target="_blank"
          className={styles.homeSocialItem}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              className={styles.homeSocialIcon}
              d="M13.5374 11.9998C13.5374 15.7637 10.507 18.815 6.76859 18.815C3.03022 18.815 0 15.7646 0 11.9998C0 8.23503 3.03045 5.18481 6.76859 5.18481C10.5067 5.18481 13.5374 8.23595 13.5374 11.9998ZM20.9629 11.9998C20.9629 15.543 19.4475 18.4151 17.5785 18.4151C15.7094 18.4151 14.1941 15.5421 14.1941 11.9998C14.1941 8.45751 15.7094 5.58451 17.5785 5.58451C19.4475 5.58451 20.9629 8.45751 20.9629 11.9998ZM24 11.9998C24 15.1744 23.467 17.7477 22.8097 17.7477C22.1523 17.7477 21.6193 15.1734 21.6193 11.9998C21.6193 8.82618 22.1523 6.25196 22.8099 6.25196C23.4675 6.25196 24 8.82549 24 11.9998Z"
              fill="white"
            />
          </svg>
        </a>
      </div>
    </div>
  );
};

export default HoverComp;
